import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tpms',
  templateUrl: './tpms.component.html',
  styleUrls: ['./tpms.component.css']
})
export class TpmsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
